import {DeleteAccountService} from "@/services/delete_account.service"

const state ={
  loading: false,
  overlay: false,
  loadingAddKategori: false,
  loadingMenuDeleteAkun: false,
  delete_akuns: [],
  totaldata: 0,
  totalpage: 0,
  count: 0
}

const actions = {
  getDataDeleteAkun({commit},opsi){
    commit('setloading',true);
    if(state.delete_akuns.length !== 0) commit('setPendings',[]);
    DeleteAccountService.getListDeleteAccount(opsi).then(data => {
      commit("setDeleteAkun", data)
      commit('setloading',false);
    }).catch(err => {
      console.log(err)
      commit('setloading',false);
    })
  },

  getCountPending({commit}){
    DeleteAccountService.getPendingDeleteAccount().then(data => {
      commit("setPendingCount", data.data)
    })
  },

  updateStatusDeleteAkun({commit,dispatch},opsi){
    DeleteAccountService.updateStatusPending(opsi).then(data => {
      commit('setPendings',[]);
      commit('setloading',true);
      dispatch('alert/success', data.msg, { root: true });
      DeleteAccountService.getListDeleteAccount({page:1,size:10}).then(response => {
        commit("setDeleteAkun", response)
        commit('setloading',false);
        DeleteAccountService.getPendingDeleteAccount().then(data => {
          commit("setPendingCount", data.data)
          commit('setloading',false);
        }).catch(err => {
          console.log("ERROR getPendingDeleteAccount")
          console.log(err)
          commit('setloading',false);
        })
      }).catch(err => {
        console.log("ERROR getDataDeleteAkun")
        console.log(err)
        commit('setloading',false);
        commit('setPendings',[]);
      })
    }).catch(error => {
      console.log("ERROR updateStatusPending")
      console.log(error)
      commit('setloading',false);
    })
  }
}

const mutations = {
  setDeleteAkun(state, value){
    state.delete_akuns=value.data.content;
    state.totaldata= value.data ? value.data.totalElements : 0;
    state.totalpage= value.data ? value.data.totalPages : 0;
  },
  setloading(state,load) {
    state.loading = load
    state.overlay = load
  },
  setPendingCount(state,load){
    state.count = load
  },
  setPendings(state,load){
    state.delete_akuns=load
  }
}

export const DeleteAkun = {
  namespaced: true,
  state,
  actions,
  mutations
};
